import React, { useEffect, useState } from 'react';
import cx from 'classnames';

import { getManagedBy } from './http';
import { journeyManagedStyles } from './styled';

const managed = {
  DRIVER_LEVEL: 'DRIVER LEVEL',
  CARRIER_LEVEL: 'CARRIER LEVEL',
  MANUAL_LEVEL: 'MANUAL LEVEL',
};

export const t = {
  managed_at: 'Managed at',
  [managed.CARRIER_LEVEL]: 'Carrier level',
  [managed.DRIVER_LEVEL]: 'Driver level',
  [managed.MANUAL_LEVEL]: 'Manual level',
};

const JourneyManaged = ({ journeyId, className }) => {
  const [managedBy, setManagedBy] = useState();

  useEffect(() => {
    (async function getStatus() {
      const data = await getManagedBy(journeyId);
      if (data) {
        setManagedBy(data);
      }
    })();
  }, [journeyId]);

  if (!managedBy) return null;

  return (
    <div data-testid="journey-managed" className={className}>
      <div className="title">{t.managed_at}</div>
      <div
        className={cx('tag', {
          driver: managedBy === managed.DRIVER_LEVEL,
          carrier: managedBy === managed.CARRIER_LEVEL,
          manual: managedBy === managed.MANUAL_LEVEL,
        })}
      >
        {t[managedBy]}
      </div>
    </div>
  );
};

export default journeyManagedStyles(JourneyManaged);
